
























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Clipboard extends Vue {
  @Prop({ default: '24' }) readonly width?: string;
  @Prop({ default: '24' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
